'use client';

import * as Toast from '@radix-ui/react-toast';
import { PropsWithChildren } from 'react';

// This provider is intended to contain any/all providers employed by Radix UI
export function RadixUiProvider({ children }: PropsWithChildren) {
  return (
    <Toast.ToastProvider>
      {children}
      <Toast.Viewport className="ToastViewport" />
    </Toast.ToastProvider>
  );
}
